// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Ufcq4pOKx{line-height:normal;word-wrap:break-word}.Ufcq4pOKx .token.punctuation{color:var(--primary-text)}.Ufcq4pOKx .token.tag{color:#0000ff}.Ufcq4pOKx .token.tag .attr-name{color:var(--code-class-name)}.Ufcq4pOKx .token.tag .attr-value{color:var(--syntax-token4)}.Ufcq4pOKx .token.tag .attr-value .punctuation:first-child{color:#F56D4F}.Ufcq4pOKx a,.Ufcq4pOKx :visited{color:var(--link-text)}.Ufcq4pOKx a:hover,.Ufcq4pOKx :visited:hover{color:var(--link-text-hover)}._28esLFXVx{margin:1em 0}._3FSc63u8x{overflow:auto}._3FSc63u8x pre{margin:0;display:inline-block}.hoSJpVJwx{display:flex;align-items:center;margin-left:-24px}.hoSJpVJwx:hover .aU1kXq93x{visibility:visible}.hoSJpVJwx .aU1kXq93x{opacity:0.5;display:flex;align-items:center;margin-right:8px;visibility:hidden}.hoSJpVJwx .aU1kXq93x img{width:20px}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"markdown": "Ufcq4pOKx",
	"padded": "_28esLFXVx",
	"code-block": "_3FSc63u8x",
	"codeBlock": "_3FSc63u8x",
	"heading": "hoSJpVJwx",
	"link-icon": "aU1kXq93x",
	"linkIcon": "aU1kXq93x"
};
module.exports = exports;
